import { render, staticRenderFns } from "./TempConfigDiseaseModal.vue?vue&type=template&id=66ddfb94&scoped=true"
import script from "./TempConfigDiseaseModal.vue?vue&type=script&lang=js"
export * from "./TempConfigDiseaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ddfb94",
  null
  
)

export default component.exports